import { render, staticRenderFns } from "./FooterLasa.vue?vue&type=template&id=0141b4fe&"
import script from "./FooterLasa.vue?vue&type=script&lang=js&"
export * from "./FooterLasa.vue?vue&type=script&lang=js&"
import style0 from "./FooterLasa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports